import React from 'react';
import styled from 'styled-components';

const TabContainer = styled.ul`
  display: flex;
  width: 100%;
  padding-bottom: 40px;
  list-style: none;
  line-height: 18px;
  font-size: 14px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fontIBMSemiBold};
`;
const TabItem = styled.li`
  padding: 0 30px;
  border-right: 1px solid rgba(132,142,156,0.5);
  cursor: pointer;
  color: ${({ isActive }) => isActive ? '#212833' : '#848E9C'};
  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    border: none;
  }
`;

type TabItemProps = {
  label: string,
  key: string,
}
type Prop = {
  activeKey: string,
  dataSource: Array<TabItemProps>,
  onTabClick: Function,
}

const TabBar = ({
  dataSource, activeKey, onTabClick,
}: Prop) => dataSource.length > 1
  ? (
    <TabContainer className="tabbar">
      {
          dataSource.map(({ label, key }, idx) => (
            <TabItem
              key={idx}
              isActive={activeKey === key}
              onClick={() => onTabClick(key)}
            >
              {label}
            </TabItem>
          ))
        }
    </TabContainer>
  )
  : null;

export default TabBar;
